import { render, staticRenderFns } from "./AgentpayList.vue?vue&type=template&id=b0d30fe0&"
import script from "./AgentpayList.vue?vue&type=script&lang=js&"
export * from "./AgentpayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports